import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cart-layout',
  templateUrl: './cart-layout.component.html',
  styleUrls: ['./cart-layout.component.scss']
})
export class CartLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
